module.exports = {
    users: 'users',
    domains: 'domains',
    words: 'words',
    users_public: 'users_public',
}